import styled from 'styled-components'

export const StyledCard = styled.div<{ $isHovered?: boolean }>`
  padding: 12px;
  border: 1px solid
    ${({ theme, $isHovered }) =>
      $isHovered ? theme.colors.primary : '#e6e6e6'};
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 200ms ease-out;
  max-width: 100%;
  box-sizing: border-box;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: ${({ theme }) => theme.colors.primary};
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 640px) {
    padding: 12px;
  }

  @media (hover: none) {
    &:hover {
      transform: none;
    }
  }
`

export const CardHeader = styled.div`
  margin-bottom: 10px;
`

export const GroupingInfo = styled.div``

export const GroupingName = styled.h3`
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  color: #1a1a1a;
  margin: 0 0 2px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const GroupingMeta = styled.p`
  font-size: 11px;
  line-height: 1.3;
  color: #666666;
  margin: 0;
`

export const MetricsRow = styled.div`
  display: flex;
  gap: 10px;
  margin: 6px 0;
  padding: 6px 0;
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;

  @media (max-width: 768px) {
    gap: 8px;
    flex-wrap: wrap;
  }
`

export const Metric = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #404040;
`

export const MetricIcon = styled.div`
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #808080;
`

export const MetricValue = styled.span`
  font-weight: 500;
`

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
  gap: 6px;
  min-width: 0;
`

export const DateText = styled.p`
  font-size: 10px;
  line-height: 1.4;
  color: #808080;
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  background: none;
  border: none;
  padding: 3px;
  cursor: pointer;
  transition: color 150ms ease-out;
  border-radius: 3px;

  &:hover {
    color: ${({ theme }) => theme.colors.primary || '#0088b8'};
    background-color: #f5f5f5;
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  @media (max-width: 640px) {
    min-height: 44px;
    padding: 8px;
  }
`

export const DeleteButton = styled(ActionButton)`
  color: ${({ theme }) => theme.colors.danger};

  &:hover {
    color: #cc0000;
    background-color: #ffebee;
  }
`
